import axios from "./httpService";

export const getSlots = ({ doctorId, slotType }) =>
  axios.get(`/v3/doctor/${doctorId}/slots?type=${slotType}`);
